export function areConstraintBoundsEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  return a.top === b.top && a.left === b.left && a.right === b.right && a.bottom === b.bottom && a.numColumns === b.numColumns;
}
export function clampDragPreviewPosition({
  sourceX,
  sourceY,
  elementWidth,
  bounds
}) {
  const clampedX = Math.max(bounds.left, Math.min(bounds.right - elementWidth, sourceX));
  const clampedY = Math.max(bounds.top, sourceY);
  return {
    deltaX: clampedX - sourceX,
    deltaY: clampedY - sourceY
  };
}